import { render, staticRenderFns } from "./OverviewAdmin.vue?vue&type=template&id=6dda156a&scoped=true&"
import script from "./OverviewAdmin.vue?vue&type=script&lang=js&"
export * from "./OverviewAdmin.vue?vue&type=script&lang=js&"
import style0 from "./OverviewAdmin.vue?vue&type=style&index=0&id=6dda156a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dda156a",
  null
  
)

export default component.exports